import { UnavailableOnWebModal } from 'utils/packages/UnavailableOnWebModal';
export var AccountType;
(function (AccountType) {
    AccountType["personal"] = "personal";
    AccountType["business"] = "business";
})(AccountType || (AccountType = {}));
export const UnavailableAccountModal = {
    show: (type, isGBUser) => {
        UnavailableOnWebModal.show(isGBUser ? `emma://chooseBank/${type}/true` : 'emma://feed', `Add ${type} account`);
    },
    hide: () => {
        UnavailableOnWebModal.hide();
    },
};
